module.exports = __webpack_public_path__ + "static/img/illus-08.487ef7f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illus-08.webp
// module id = 109
// module chunks = 0